export default {
  PENDING: 'pending',
  IN_PROGRESS: 'in-progress',
  COMPLETE: 'complete',
};
